import React, {useCallback, useContext} from 'react';
import {useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';

import {CriteriaStrip} from 'src/components/criteria-strip';
import {selectCriteriaStripView} from 'src/components/criteria-strip/services/criteria-strip-slice';
import {useEventTracking} from 'src/hooks/useEventTracking';

import {FlatButton} from '@pb/kit-component-button';
import {Integer} from '@pb/kit-component-formatters';
import {Group} from '@pb/kit-component-group';
import Typography from '@pb/kit-component-typography';
import {LocaleContext} from '@pb/kit-context-locale';
import {pluralize} from '@pb/kit-formatters';

import {
    accountSearchResultHeader,
    accountSearchResultHeaderLiveCount,
    accountSearchResultHeaderSeparator,
} from './account-search-result-header.module.styl';


type Props = {
    searchId: string,
    totalCount: number,
};

export const AccountSearchResultHeader = ({searchId, totalCount}: Props) => {
    const navigate = useNavigate();
    const {locale} = useContext(LocaleContext);
    const {searchCriteriaOpen} = useEventTracking();

    const stripData = useSelector(selectCriteriaStripView);

    const onOpenCriteria = useCallback(() => {
        searchCriteriaOpen({place: 'Modify Criteria Button'});
        navigate(`/search-criteria/${searchId}/accounts`);
    }, [searchId, navigate, searchCriteriaOpen]);

    return (
        <Group direction="v" gap="m" className={accountSearchResultHeader} alignItems="start">
            <Group alignItems="center">
                <Typography variant="heading-level-1">Accounts Search</Typography>
                {totalCount ? (
                    <span className={accountSearchResultHeaderSeparator}/>
                ) : null}
                {totalCount ? (
                    <Group gap="s" className={accountSearchResultHeaderLiveCount}>
                        <span>
                            {Integer.format(totalCount, locale, {showZeros: true})}
                        </span>
                        <span>
                            {pluralize(`Account[s]`, totalCount)}
                        </span>
                    </Group>
                ) : null}
            </Group>
            <Group gap="m" direction="v" alignItems="start">
                <FlatButton
                    disabled={false}
                    onClick={onOpenCriteria}>
                    <strong>
                        Modify Criteria ({stripData?.length})
                    </strong>
                </FlatButton>
                <CriteriaStrip activeTab="accounts"/>
            </Group>
        </Group>
    );
};

